import {Input} from "../../../basic/input";
import {Label} from "../../../basic/label";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";

interface UserFormProps {
    email: string;
    firstName: string;
    lastName: string;
    onEmailChange: (email: string) => void;
    onFirstNameChange: (firstName: string) => void;
    onLastNameChange: (lastName: string) => void;
}

export function UserForm({
                             email,
                             firstName,
                             lastName,
                             onEmailChange,
                             onFirstNameChange,
                             onLastNameChange
                         }: UserFormProps) {
    const {t} = useTranslationWithKeys();

    return (
        <>
            <div className="space-y-2 md:col-span-2">
                <Label htmlFor="userEmail">{t('admin.users.createUserDialog.emailAddress')} *</Label>
                <Input
                    id="userEmail"
                    type="email"
                    value={email}
                    onChange={(e) => onEmailChange(e.target.value)}
                    placeholder={t('admin.users.createUserDialog.emailPlaceholder')}
                />
            </div>
            <div className="space-y-2">
                <Label htmlFor="firstName">{t('admin.users.editUser.firstName')}</Label>
                <Input
                    id="firstName"
                    value={firstName}
                    onChange={(e) => onFirstNameChange(e.target.value)}
                    placeholder={t('admin.users.editUser.firstNamePlaceholder')}
                />
            </div>
            <div className="space-y-2">
                <Label htmlFor="lastName">{t('admin.users.editUser.lastName')}</Label>
                <Input
                    id="lastName"
                    value={lastName}
                    onChange={(e) => onLastNameChange(e.target.value)}
                    placeholder={t('admin.users.editUser.lastNamePlaceholder')}
                />
            </div>
        </>
    );
}